import create from 'zustand'

import { StatusTypes, StatusErrorTypes } from 'types/status'
import {
  MerchantBankAccountsDataTypes,
} from 'types/merchantBankAccounts'

interface MerchantBankAccountStoreTypes {
  merchantBankAccountsModErrors: StatusErrorTypes
  merchantBankAccountsModErrorsSet: (
    merchantBankAccountsModErrors: StatusErrorTypes
  ) => void
  merchantBankAccountsModStatus: StatusTypes
  merchantBankAccountsModStatusSet: (merchantBankAccountsModStatus: StatusTypes) => void
  merchantBankAccounts: MerchantBankAccountsDataTypes[]
  merchantBankAccountsSet: (merchantBankAccounts: MerchantBankAccountsDataTypes[]) => void
  merchantBankAccountsLookup: MerchantBankAccountsDataTypes[]
  merchantBankAccountsLookupSet: (
    merchantBankAccounts: MerchantBankAccountsDataTypes[]
  ) => void
}

export const useMerchantBankAccountsStore = create<MerchantBankAccountStoreTypes>(
  (set) => ({
    merchantBankAccountsModErrors: '',
    merchantBankAccountsModErrorsSet: (merchantBankAccountsModErrors) => {
      set({
        merchantBankAccountsModErrors,
      })
    },
    merchantBankAccountsModStatus: 'idle',
    merchantBankAccountsModStatusSet: (merchantBankAccountsModStatus) => {
      set({
        merchantBankAccountsModStatus,
      })
    },
    merchantBankAccounts: [],
    merchantBankAccountsSet: (merchantBankAccounts) => {
      set({
        merchantBankAccounts,
      })
    },
    merchantBankAccountsLookup: [],
    merchantBankAccountsLookupSet: (merchantBankAccountsLookup) => {
      set({
        merchantBankAccountsLookup,
      })
    },
  })
)

interface MerchantBankAccountsLookupStoreTypes {
  merchantBankAccountsLookupModErrors: StatusErrorTypes
  merchantBankAccountsLookupModErrorsSet: (
    merchantBankAccountsLookupModErrors: StatusErrorTypes
  ) => void
  merchantBankAccountsLookupModStatus: StatusTypes
  merchantBankAccountsLookupModStatusSet: (
    merchantBankAccountsLookupModStatus: StatusTypes
  ) => void
  merchantBankAccountsLookup: MerchantBankAccountsDataTypes[]
  merchantBankAccountsLookupSet: (
    merchantBankAccountsLookup: MerchantBankAccountsDataTypes[]
  ) => void
}

export const useMerchantBankAccountsLookupStore =
  create<MerchantBankAccountsLookupStoreTypes>((set) => ({
    merchantBankAccountsLookupModErrors: '',
    merchantBankAccountsLookupModErrorsSet: (merchantBankAccountsLookupModErrors) => {
      set({
        merchantBankAccountsLookupModErrors,
      })
    },
    merchantBankAccountsLookupModStatus: 'idle',
    merchantBankAccountsLookupModStatusSet: (merchantBankAccountsLookupModStatus) => {
      set({
        merchantBankAccountsLookupModStatus,
      })
    },
    merchantBankAccountsLookup: [],
    merchantBankAccountsLookupSet: (merchantBankAccountsLookup) => {
      set({
        merchantBankAccountsLookup,
      })
    },
  }))